// extracted by mini-css-extract-plugin
export default {"inputGroup":"inputGroup__U9NJV"};